import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import ComboBox from '../../../../Components/ComboBox'
import CustomButton from '../../../../Components/CustomButton/CustomButton'
import { Input } from '../../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../../utils/api'
import { currentDate } from '../../../../utils/helpers'
import urls from '../../../../utils/urls'
import { UTILISATION } from 'utils/constants'
import EditIcon from '@mui/icons-material/Edit'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
export default function CreateOperationForm({ setOperations }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [moterType, setMotortype] = useState([])
  const [carac, setCarac] = useState('')
  const [subType, setSubType] = useState('')
  const [typeObject, setTypeObject] = useState(0)
  const [immobiliers, setImmobiliers] = useState([])
  const [vehicules, setVehicules] = useState([])
  const [vehiculesTypes, setVehiculesTypes] = useState([])
  const [typeDeBien, setTypeDeBien] = useState([])

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      EquipementType: '',
      EquipementSubType: '',
      EquipementCarac: '',
      EquipementName: '',
    },
  })

  const typeObj = [
    { label: 'Véhicules', id: 1 },
    { label: 'Immobilier', id: 2 },
    { label: 'Autres', id: 3 },
  ]
  useEffect(() => {}, [])

  const handleClickOpen = () => {
    setOpen(true)
    setTypeObject(0)
    fetchMotorTypes()
    fetchVehiclesTypes()
    fetchImmoFootPrint1()
  }

  const handleClose = () => {
    setOpen(false)
    reset()
    setTypeObject(0)
    setSubType('')
    setCarac('')
  }

  const fetchImmobiliers = async (v1, v2) => {
    let elements = document.getElementsByName('EquipementName')
    elements.forEach((v) => {
      v = v.getElementsByClassName('MuiAutocomplete-clearIndicator')
      if (v.length > 0) v[0].click()
    })
    setValue('EquipementName', '')
    setImmobiliers([])
    const url = urls.fetchAllImmobiliers + `?utilisation=${v2}&type_de_bien=${v1}`
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterImmobiliers = []
      data.forEach((v) => {
        filterImmobiliers.push({ id: v.id, label: `${v.nom}` })
      })
      setImmobiliers([...filterImmobiliers])
    }
  }
  const fetchVehicules = async (v1, v2) => {
    let elements = document.getElementsByName('EquipementName')
    elements.forEach((v) => {
      v = v.getElementsByClassName('MuiAutocomplete-clearIndicator')
      if (v.length > 0) v[0].click()
    })
    setValue('EquipementName', '')
    setVehicules([])
    const url = urls.fetchVehicles + `?vehicleType=${v1}&Motortype=${v2}`
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterVehicules = []
      data.forEach((v) => {
        filterVehicules.push({ id: v.id, label: `${v.Name}` })
      })
      setVehicules([...filterVehicules])
    }
  }
  const fetchImmoFootPrint1 = async () => {
    const url = '/api/domicile/get-immofootprint1/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const energy_classification = []
      const type_de_bien = []
      const type_de_chauffage = []
      const norme = []
      const type_chauffe_eau = []
      const nombre_habitant = []
      const superficiess = []
      data.forEach((v) => {
        if (v.consumption_post === 'Classe énérgétique')
          energy_classification.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === 'Type de bien')
          type_de_bien.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === 'Type de chauffage')
          type_de_chauffage.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === 'Norme') norme.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === 'Type de chauffe eau')
          type_chauffe_eau.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === "Nombre d'habitant")
          nombre_habitant.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === 'Superficie')
          superficiess.push({ label: `${v.answer}`, id: v.id })
      })
      setTypeDeBien([...type_de_bien])
    }
  }

  const onSubmit = async (data) => {
    let payload = {}
    if (data.EquipementType.id === 1 || data.EquipementType.id === 2) {
      payload = {
        ...data,
        EquipementType: data.EquipementType.label,
        EquipementSubType: data.EquipementSubType.label,
        EquipementCarac: data.EquipementCarac.label,
        EquipementName: data.EquipementName.label,
        ObjectId: data.EquipementName.id,
      }
    } else {
      payload = {
        ...data,
        EquipementType: data.EquipementType.label,
      }
    }

    const response = await makePostRequest(urls.crudEntretienOperations, payload, {}, true)
    if (response.status === 201) {
      setOperations((operations) => ({
        ...operations,
        results: [...operations.results, response.data],
        count: operations.count + 1,
      }))
      handleClose()
    }
  }
  const fetchVehiclesTypes = async () => {
    const url = urls.fetchVehiclesTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.vehicletype}`, id: v.id })
      })
      setVehiculesTypes([...filterTypes])
    }
  }

  const fetchMotorTypes = async () => {
    const url = urls.fetchMotorTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.motor_type}`, id: v.id })
      })
      setMotortype([...filterTypes])
    }
  }

  const clearData = () => {
    reset()
    setCarac('')
    setSubType('')
  }
  return (
    <>
      {isMobile ? (
        <AddCircleIcon onClick={handleClickOpen} />
      ) : (
        // LAP-733 (GE022)
        <CustomButton onClick={handleClickOpen}>{t('maintenance.btnCreate')}</CustomButton>
      )}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ backgroundColor: '#202020' }}>Ajout MaintenacePlan</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                if (j.id === 1) {
                  clearData()
                  setTypeObject(1)
                } else if (j.id === 2) {
                  clearData()
                  setTypeObject(2)
                } else if (j.id === 3) {
                  clearData()
                  setTypeObject(3)
                }
                setValue('EquipementType', j)
              }}
              label="Equipement Type"
              data={typeObj}
              name="EquipementType"
              required={true}
            />
            {typeObject === 1 ? (
              <>
                <ComboBox
                  handleAutoComplete={(e, j) => {
                    setValue('EquipementSubType', j)
                    setSubType(j.id)
                    fetchVehicules(j.id, carac)
                  }}
                  label="Equipement Sub Type"
                  data={vehiculesTypes}
                  name="EquipementSubType"
                  required={true}
                />
                <ComboBox
                  handleAutoComplete={(e, j) => {
                    setValue('EquipementCarac', j)
                    setCarac(j.id)
                    fetchVehicules(subType, j.id)
                  }}
                  label="Equipement Carac"
                  data={moterType}
                  name="EquipementCarac"
                  required={true}
                />
                <ComboBox
                  handleAutoComplete={(e, j) => setValue('EquipementName', j)}
                  label="Equipement Name"
                  data={vehicules}
                  name="EquipementName"
                  required={true}
                />
              </>
            ) : (
              ''
            )}
            {typeObject === 2 ? (
              <>
                <ComboBox
                  handleAutoComplete={(e, j) => {
                    setValue('EquipementSubType', j)
                    setSubType(j.id)
                    fetchImmobiliers(j.id, carac)
                  }}
                  label="Equipement Sub Type"
                  data={typeDeBien}
                  name="EquipementSubType"
                  required={true}
                />
                <ComboBox
                  handleAutoComplete={(e, j) => {
                    setValue('EquipementCarac', j)
                    setCarac(j.label)
                    fetchImmobiliers(subType, j.label)
                  }}
                  label="Equipement Carac"
                  data={UTILISATION}
                  name="EquipementCarac"
                  required={true}
                />
                <ComboBox
                  handleAutoComplete={(e, j) => setValue('EquipementName', j)}
                  label="Equipement Name"
                  data={immobiliers}
                  name="EquipementName"
                  required={true}
                />
              </>
            ) : (
              ''
            )}

            {typeObject === 3 ? (
              <>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'text',
                    required: true,
                    size: 'small',
                  }}
                  rules={{ required: true }}
                  name="EquipementSubType"
                  label="Equipement Sub Type"
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'text',
                    required: true,
                    size: 'small',
                  }}
                  rules={{ required: true }}
                  name="EquipementCarac"
                  label="Equipement Carac"
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'text',
                    required: true,
                    size: 'small',
                  }}
                  rules={{ required: true }}
                  name="EquipementName"
                  label="Equipement Name"
                />
              </>
            ) : (
              ''
            )}
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
